import EnumCommon from './EnumCommon';
class ApiaryStatus extends EnumCommon {
    labels() {
        return {
            [1]: 'models/apiaries.statuses.awaiting',
            [2]: 'models/apiaries.statuses.accepted',
            [4]: 'models/apiaries.statuses.deleted',
            [5]: 'models/apiaries.statuses.rejected',
        };
    }
}
ApiaryStatus.NAME = 'ApiaryStatus';
ApiaryStatus.AWAITING = new ApiaryStatus(1);
ApiaryStatus.ACCEPTED = new ApiaryStatus(2);
ApiaryStatus.DELETED = new ApiaryStatus(4);
ApiaryStatus.REJECTED = new ApiaryStatus(5);
export default ApiaryStatus;
